import {
  obtenerCrg,
  obtenerPadres,
  obtenerAbuelos,
  // obtenerBisAbuelos,
  obtenerGenealogia,
  obtenerParametros
} from '../service/apiPdfs';

const handleVerCertificado = async (rowData) => {
  // Objeto final que unificará toda la data
  const datosCompletos = {};
  let urlDestino='';
  // 1. Datos del animal (hijo)

  const resultadoParametros = await obtenerParametros();
  datosCompletos.parametros = resultadoParametros;

  const resultadoHijo = await obtenerCrg(rowData.CONSECUTIVO);
  datosCompletos.hijo = resultadoHijo;
  urlDestino="https://www.ancogenecop.com/APIANCO/models/pdfCRG.php";

  // 2. Padres
  const tienePadres = await obtenerPadres(rowData);
  console.log("el valor de los padres "+tienePadres)
  if (tienePadres === 1) {
    const resultadoPadres = await obtenerGenealogia(rowData);
    datosCompletos.padres = resultadoPadres;
  }

  //3. Abuelos
  const tieneAbuelos = await obtenerAbuelos(rowData);
  if (tieneAbuelos === 1) {
    const resultadoAbuelos = await obtenerGenealogia();
    datosCompletos.abuelos = resultadoAbuelos;
  }

  // 4. Bisabuelos
  // const tieneBisabuelos = await obtenerBisAbuelos(rowData);
  // if (tieneBisabuelos === 1) {
  //   const resultadoBisabuelos = await obtenerGenealogia();
  //   datosCompletos.bisabuelos = resultadoBisabuelos;
  // }

  if(tienePadres==1){
    urlDestino="https://www.ancogenecop.com/APIANCO/models/pdfCRGPadres.php";
  }
   if(tieneAbuelos==1){
     urlDestino="https://www.ancogenecop.com/APIANCO/models/pdfCRGAbuelos.php";
   }
  // if(tieneBisabuelos==1){
  //   urlDestino="https://www.ancogenecop.com/APIANCO/models/pdfCRGBisAbuelos.php";
  // }

  
  // Enviar todos los datos unificados al PHP que genera el PDF
  const response = await fetch(urlDestino, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(datosCompletos)
  });

  // Abrir el PDF en una nueva pestaña
  const blob = await response.blob();
  const url = window.URL.createObjectURL(blob);
  window.open(url, '_blank');
};

export default handleVerCertificado;
